import API_BASE from "../config.js";
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../components/Layout";
import { Dica, BotaoDica } from "../components/Dica";
import Modal from "../components/Modal";
import { adicionarNotificacao } from "../components/Header";
import ModalOrcamentoCompleto from "../components/ModalOrcamentoCompleto";
import { authFetch } from "../services/authFetch";
// Mesmo modulo de formatacao usado por Clientes.js e OS.js. Uma unica
// implementacao de mascara no sistema inteiro -- e o que garante que a
// subida futura do restante nao entre em conflito com isto aqui.
import { fmt, soDigitos } from "../services/formato";
import PainelWhatsApp from "../components/PainelWhatsApp";
import { useTranslation } from "react-i18next";
import useTextosSegmento from "../i18n/useTextosSegmento";


// A montagem da mensagem e o envio pelo WhatsApp vivem FORA desta tela:
// services/mensagens.js monta o texto de cada evento (e guarda o modelo
// proprio da oficina) e components/PainelWhatsApp.jsx desenha o painel de
// envio. Esta pagina so diz QUAL evento e e QUAIS dados ele tem -- por isso
// nao ha aqui nenhum texto de mensagem nem nenhuma URL de WhatsApp.

// Extrai tenant_id do JWT token - evita conflito entre tenants
function getTenantIdFromToken() {
  try {
    const token = (sessionStorage.getItem("access_token")||localStorage.getItem("access_token"));
    if (!token) return (sessionStorage.getItem("tenant_id")||localStorage.getItem("tenant_id")) || "1";
    const payload = JSON.parse(atob(token.split(".")[1]));
    return String(payload.tenant_id || (sessionStorage.getItem("tenant_id")||localStorage.getItem("tenant_id")) || "1");
  } catch { return (sessionStorage.getItem("tenant_id")||localStorage.getItem("tenant_id")) || "1"; }
}

// Mesma logica de components/Layout.js: chave de cache de config isolada por tenant
function getConfigKey() {
  try {
    const token = sessionStorage.getItem("access_token") || localStorage.getItem("access_token");
    if (!token) return "saas_config";
    const payload = JSON.parse(atob(token.split(".")[1]));
    return "saas_config_tenant_" + (payload.tenant_id || "1");
  } catch { return "saas_config"; }
}

const API = "" + API_BASE + "/api/v1/dados";

const ETAPAS = [
  { key: "solicitacao",       label: "Solicitacao",       cor: "#6366f1", bg: "#6366f122" },
  { key: "pre_cadastro",      label: "Pre-Cadastro",      cor: "#8b5cf6", bg: "#8b5cf622" },
  { key: "orcamento_enviado", label: "Orcamento Enviado", cor: "#f59e0b", bg: "#f59e0b22" },
  { key: "confirmado",        label: "Confirmado",          cor: "#22c55e", bg: "#22c55e22" },
  { key: "convertido_os",     label: "Convertido em OS",  cor: "#3b82f6", bg: "#3b82f622" },
];

const PROXIMO = {
  solicitacao: "pre_cadastro",
  pre_cadastro: "orcamento_enviado",
  orcamento_enviado: "confirmado",
  confirmado: "convertido_os",
};

function BtnFechar({ onClick }) {
  return <button onClick={onClick} style={{background:"var(--bg4)",border:"none",borderRadius:8,color:"var(--text2)",cursor:"pointer",fontSize:20,lineHeight:1,padding:"4px 10px"}}>x</button>;
}

// Colunas onde faz sentido cobrar resposta do cliente -- se o card fica
// parado tempo demais aqui, o dono da oficina precisa ser avisado pra
// correr atras (cliente que nao respondeu o pre-cadastro ou nao confirmou
// o orcamento). Nas outras colunas (Solicitacao, Confirmado, Convertido)
// nao faz sentido piscar: ou acabou de chegar, ou ja andou.
const ETAPAS_COM_ALERTA_PARADO = ["pre_cadastro", "orcamento_enviado"];
const HORAS_PARA_ALERTA = 48;

function horasParado(ag) {
  const dataRef = ag.updated_at || ag.created_at;
  if (!dataRef) return 0;
  const t = new Date(dataRef).getTime();
  if (Number.isNaN(t)) return 0;
  return (Date.now() - t) / (1000 * 60 * 60);
}

// ===========================================================================
// SELETOR DE DATA E HORA  (14/09/2026)
// ---------------------------------------------------------------------------
// Substitui o <input type="datetime-local"> nativo, que tinha aparencia de
// caixa de sistema operacional e mudava em cada navegador.
//
// CONTRATO: entrega e recebe "AAAA-MM-DDTHH:mm" -- exatamente o que o input
// nativo entregava. O codigo de gravacao nao muda uma linha.
// ===========================================================================

// Expediente padrao do sistema (0 = domingo ... 6 = sabado).
// Este objeto governa a grade de horarios, a contagem de vagas, o ajuste fino
// e quais dias entram na trilha -- tudo junto. E o unico lugar a mexer no dia
// em que o horario virar configuracao por oficina.
const EXPEDIENTE = {
  0: [],                // domingo fechado
  1: [[7, 0, 18, 0]],
  2: [[7, 0, 18, 0]],
  3: [[7, 0, 18, 0]],
  4: [[7, 0, 18, 0]],
  5: [[7, 0, 18, 0]],
  6: [[7, 0, 13, 0]],   // sabado ate as 13h
};
const PASSO_GRADE = 30;     // grade rapida, em minutos
const PASSO_FINO = 5;       // ajuste fino, em minutos
const MEIO_DIA = 12 * 60;
const DIAS_NA_TRILHA = 14;
const DOW_CURTO = ["dom", "seg", "ter", "qua", "qui", "sex", "sab"];
const MES_CURTO = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];

const dd2 = (n) => String(n).padStart(2, "0");
const janelasDe = (d) => (d ? (EXPEDIENTE[d.getDay()] || []) : []);
const abreNoDia = (d) => janelasDe(d).length > 0;
const chaveData = (d) => d.getFullYear() + "-" + dd2(d.getMonth() + 1) + "-" + dd2(d.getDate());
const meiaNoiteDe = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
const minDe = (hm) => parseInt(hm, 10) * 60 + parseInt(hm.slice(3), 10);
const hhmmDe = (m) => dd2(Math.floor(m / 60)) + ":" + dd2(m % 60);
const dentroExpediente = (d, m) => janelasDe(d).some(j => m >= j[0] * 60 + j[1] && m < j[2] * 60 + j[3]);

// Leitura tolerante: aceita "AAAA-MM-DDTHH:mm", com segundos, e com espaco no
// lugar do T. Nao usa new Date() de proposito -- Date interpreta fuso e ja nos
// custou 3 horas de diferenca uma vez.
function dataParteDe(valor) {
  const m = String(valor || "").match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? m[0] : null;
}
function horaParteDe(valor) {
  const m = String(valor || "").match(/[T ](\d{2}):(\d{2})/);
  return m ? m[1] + ":" + m[2] : null;
}
function dataParaObjeto(valor) {
  const s = dataParteDe(valor);
  if (!s) return null;
  const [a, me, di] = s.split("-").map(Number);
  return new Date(a, me - 1, di);
}

function slotsDoDia(d) {
  const out = [];
  janelasDe(d).forEach(j => {
    for (let m = j[0] * 60 + j[1]; m < j[2] * 60 + j[3]; m += PASSO_GRADE) out.push(m);
  });
  return out;
}

// Transparencia a partir do hex do ETAPAS[] -- evita color-mix(), que so
// funciona em navegador recente e este sistema roda em maquina de oficina.
function comAlfa(hex, a) {
  const h = String(hex || "").replace("#", "");
  if (h.length !== 6) return "rgba(148,163,184," + a + ")";
  const n = parseInt(h, 16);
  if (Number.isNaN(n)) return "rgba(148,163,184," + a + ")";
  return "rgba(" + ((n >> 16) & 255) + "," + ((n >> 8) & 255) + "," + (n & 255) + "," + a + ")";
}

// Agendamentos daquele dia. Ignora cancelados e, na edicao, o proprio
// registro -- senao o agendamento entraria em conflito consigo mesmo.
function agsDoDia(lista, dia, idIgnorar) {
  if (!dia || !Array.isArray(lista)) return [];
  const k = chaveData(dia);
  return lista.filter(a =>
    a && a.data_agendamento &&
    a.status !== "cancelado" &&
    !(idIgnorar && a.id === idIgnorar) &&
    dataParteDe(a.data_agendamento) === k
  );
}

// Cor do dia: vence o status mais adiantado no fluxo (a ordem do ETAPAS[]).
// Parado ha +48h manda em tudo -- mesma regra que ja faz o card piscar.
function statusDoDia(ags) {
  if (!ags.length) return null;
  const atrasado = ags.some(a => ETAPAS_COM_ALERTA_PARADO.includes(a.status) && horasParado(a) >= HORAS_PARA_ALERTA);
  let idx = 0;
  ags.forEach(a => {
    const i = ETAPAS.findIndex(e => e.key === a.status);
    if (i > idx) idx = i;
  });
  const etapa = ETAPAS[idx] || ETAPAS[0];
  return { cor: etapa.cor, rotulo: etapa.label, qtd: ags.length, atrasado };
}

// Animacoes e estados que estilo inline nao alcanca (keyframes, :hover,
// :disabled). Prefixo sdh- para nao colidir com nada do sistema.
const CSS_SELETOR = `
.sdh-trilha{display:flex;gap:8px;overflow-x:auto;padding:10px 2px 12px;scrollbar-width:thin}
.sdh-trilha::-webkit-scrollbar{height:6px}
.sdh-trilha::-webkit-scrollbar-thumb{background:var(--border2,#38445f);border-radius:3px}
.sdh-dia{flex:0 0 68px;position:relative;background:rgba(30,39,60,.6);border:1px solid rgba(120,146,196,.22);
  border-radius:13px;color:var(--text);cursor:pointer;font-family:inherit;padding:11px 5px 9px;text-align:center;
  display:flex;flex-direction:column;gap:2px;backdrop-filter:blur(9px) saturate(130%);
  -webkit-backdrop-filter:blur(9px) saturate(130%);box-shadow:inset 0 1px 0 rgba(255,255,255,.1);
  transition:transform .16s cubic-bezier(.2,.7,.3,1),border-color .16s;
  animation:sdh-entra .42s cubic-bezier(.2,.7,.3,1) both;animation-delay:calc(var(--i,0) * 55ms)}
@keyframes sdh-entra{from{opacity:0;transform:translateY(14px) scale(.94)}to{opacity:1;transform:none}}
.sdh-dia:hover:not(:disabled){transform:translateY(-3px);border-color:var(--st,#38445f)}
.sdh-dia:disabled{opacity:.34;cursor:not-allowed}
.sdh-dia.on{border-color:#7ba4f5!important}
.sdh-dia.piscando{animation:sdh-entra .42s cubic-bezier(.2,.7,.3,1) both,sdh-pulso 1.9s ease-in-out .6s infinite}
@keyframes sdh-pulso{0%,100%{box-shadow:inset 0 1px 0 rgba(255,255,255,.1),0 0 0 1px rgba(239,68,68,.3),0 0 0 0 rgba(239,68,68,.4)}
  50%{box-shadow:inset 0 1px 0 rgba(255,255,255,.1),0 0 0 1px rgba(239,68,68,.75),0 0 18px 3px rgba(239,68,68,.28)}}
.sdh-linha{animation:sdh-cai .4s cubic-bezier(.2,.75,.3,1) both;animation-delay:calc(var(--i,0) * 70ms)}
@keyframes sdh-cai{from{opacity:0;transform:translateY(-9px)}to{opacity:1;transform:none}}
.sdh-slot{position:relative;overflow:hidden;background:rgba(26,32,53,.6);border:1px solid rgba(120,146,196,.22);
  border-radius:9px;color:var(--text);cursor:pointer;font-family:inherit;font-size:13px;font-weight:600;
  padding:9px 4px;font-variant-numeric:tabular-nums;
  transition:border-color .15s,transform .12s;
  animation:sdh-entra .34s cubic-bezier(.2,.7,.3,1) both;animation-delay:calc(var(--i,0) * 22ms)}
.sdh-slot:hover:not(:disabled){border-color:var(--accent2);transform:translateY(-1px)}
.sdh-slot:disabled{background:rgba(18,23,36,.7);border-color:#242c3e;color:#4a5468;cursor:not-allowed;text-decoration:line-through}
.sdh-slot.on{background:linear-gradient(160deg,var(--accent),#1d4ed8);border-color:#7ba4f5;color:#fff;
  box-shadow:0 0 0 1px rgba(123,164,245,.5),0 10px 26px -10px rgba(37,99,235,1)}
.sdh-slot.on::after{content:"";position:absolute;inset:0;
  background:linear-gradient(105deg,transparent 35%,rgba(255,255,255,.38) 50%,transparent 65%);
  transform:translateX(-120%);animation:sdh-varre .75s ease-out 1}
@keyframes sdh-varre{to{transform:translateX(120%)}}
.sdh-chip,.sdh-step{background:rgba(40,52,78,.5);border:1px solid rgba(120,146,196,.22);color:var(--text2);
  cursor:pointer;font-family:inherit;transition:border-color .16s,color .16s,background .16s}
.sdh-chip{border-radius:20px;font-size:12px;font-weight:600;padding:5px 13px}
.sdh-chip:hover,.sdh-step:hover:not(:disabled){border-color:var(--accent2);color:var(--text)}
.sdh-chip.on{background:rgba(59,130,246,.2);border-color:var(--accent2);color:#d3e2ff}
.sdh-step{border-radius:8px;color:var(--text);font-size:12px;font-weight:700;padding:7px 12px}
.sdh-step:disabled{opacity:.35;cursor:not-allowed}
@media (prefers-reduced-motion:reduce){.sdh-dia,.sdh-slot,.sdh-linha,.sdh-dia.piscando{animation:none!important}
  .sdh-slot.on::after{animation:none!important;opacity:0}}
`;

function EstiloSeletor() {
  return <style>{CSS_SELETOR}</style>;
}

// ---------------------------------------------------------------------------
// valor / aoMudar: "AAAA-MM-DDTHH:mm". agendamentos: a lista ja carregada da
// tela. idIgnorar: na edicao, o id do proprio registro.
// ---------------------------------------------------------------------------
function SeletorDataHora({ valor, aoMudar, agendamentos, idIgnorar, t }) {
  const [base, setBase] = useState(0);          // deslocamento da trilha, em dias
  const [diaLocal, setDiaLocal] = useState(null);

  const hoje = meiaNoiteDe(new Date());
  const agoraMin = new Date().getHours() * 60 + new Date().getMinutes();
  const diaDoValor = dataParaObjeto(valor);
  const dia = diaLocal || diaDoValor;
  const hora = horaParteDe(valor);

  const ags = agsDoDia(agendamentos, dia, idIgnorar);
  const ocupados = ags.map(a => horaParteDe(a.data_agendamento)).filter(Boolean);

  const escolherDia = (d) => {
    setDiaLocal(d);
    // Trocar de dia invalida o horario: o que estava livre ontem pode estar
    // ocupado hoje. Limpa e obriga a escolher de novo, de proposito.
    if (valor) aoMudar("");
  };
  const escolherHora = (hm) => { if (dia) aoMudar(chaveData(dia) + "T" + hm); };

  // ---- trilha de dias ----
  const dias = [];
  for (let i = 0; dias.length < DIAS_NA_TRILHA && i < 60; i++) {
    const d = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate() + i + base);
    if (abreNoDia(d)) dias.push(d);
  }
  // Editar um agendamento antigo (ou muito futuro) deixava a trilha sem
  // nenhum cartao aceso: o dia marcado ficava fora da faixa visivel e a tela
  // dava a impressao de que nada estava escolhido, mesmo o resumo dizendo o
  // contrario. O dia do valor entra na frente da trilha, sempre.
  if (dia && !dias.some(d => chaveData(d) === chaveData(dia))) dias.unshift(dia);

  const amanha = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate() + 1);
  const atalhos = [[t("agendamentos.hoje", "Hoje"), hoje], [t("agendamentos.amanha", "Amanha"), amanha]]
    .filter(([, d]) => abreNoDia(d));

  // ---- horarios ----
  const todos = slotsDoDia(dia);
  const blocos = [
    [t("agendamentos.manha", "Manha"), todos.filter(m => m < MEIO_DIA)],
    [t("agendamentos.tarde", "Tarde"), todos.filter(m => m >= MEIO_DIA)],
  ].filter(([, arr]) => arr.length > 0);

  const ehHoje = dia && meiaNoiteDe(dia).getTime() === hoje.getTime();
  let idx = 0;

  return (
    <div style={{background:"linear-gradient(150deg, rgba(37,99,235,.16), rgba(139,92,246,.07) 55%, transparent)",border:"1px solid rgba(120,146,196,.22)",borderRadius:14,boxShadow:"inset 0 1px 0 rgba(255,255,255,.1)",display:"flex",flexDirection:"column",gap:14,padding:16,position:"relative"}}>
      <EstiloSeletor />
      <span style={{alignItems:"center",color:"#9dc0ff",display:"flex",fontSize:11,fontWeight:800,gap:7,letterSpacing:"0.07em",textTransform:"uppercase"}}>
        <span aria-hidden="true">&#128197;</span>{t("agendamentos.data_hora", "Data e hora")}
      </span>

      {/* atalhos e navegacao da trilha */}
      <div style={{display:"flex",flexWrap:"wrap",gap:7}}>
        {atalhos.map(([rot, d]) => (
          <button key={rot} type="button" onClick={() => escolherDia(d)}
            className={"sdh-chip" + (dia && chaveData(dia) === chaveData(d) ? " on" : "")}>{rot}</button>
        ))}
        {base > 0 && (
          <button type="button" onClick={() => setBase(Math.max(0, base - 7))} className="sdh-chip">
            &#8249; {t("agendamentos.semana_anterior", "Semana anterior")}
          </button>
        )}
        <button type="button" onClick={() => setBase(base + 7)} className="sdh-chip">
          {t("agendamentos.proxima_semana", "Proxima semana")} &#8250;
        </button>
      </div>

      <div className="sdh-trilha">
        {dias.map((d, i) => {
          const agsD = agsDoDia(agendamentos, d, idIgnorar);
          const st = statusDoDia(agsD);
          const livres = slotsDoDia(d).length - agsD.length;
          const sel = dia && chaveData(dia) === chaveData(d);
          const sabado = d.getDay() === 6;
          const cor = st ? (st.atrasado ? "#ef4444" : st.cor) : null;
          return (
            <button key={chaveData(d)} type="button" disabled={livres <= 0}
              className={"sdh-dia" + (sel ? " on" : "") + (st && st.atrasado ? " piscando" : "")}
              onClick={() => escolherDia(d)}
              title={(sabado ? "Sabado 07:00-13:00" : "07:00-18:00") + (st ? " \u00b7 " + st.qtd + " agendamento(s) \u00b7 " + st.rotulo + (st.atrasado ? " \u00b7 ha um parado ha +48h" : "") : " \u00b7 " + livres + " horarios livres")}
              style={{
                "--i": i,
                "--st": cor || "#38445f",
                background: sel ? "linear-gradient(160deg, rgba(37,99,235,.9), rgba(29,78,216,.78))" : undefined,
                borderColor: !sel && cor ? comAlfa(cor, 0.5) : undefined,
                boxShadow: !sel && cor && !st.atrasado
                  ? "inset 0 1px 0 rgba(255,255,255,.1), 0 0 0 1px " + comAlfa(cor, 0.18) + ", 0 10px 26px -14px " + cor
                  : (sel ? "inset 0 1px 0 rgba(255,255,255,.25), 0 12px 30px -12px rgba(37,99,235,1)" : undefined),
              }}>
              <span style={{color:sel?"#cfe0ff":"var(--text3)",fontSize:9.5,fontWeight:700,letterSpacing:"0.1em",textTransform:"uppercase"}}>{DOW_CURTO[d.getDay()]}</span>
              <span style={{fontSize:20,fontWeight:700,lineHeight:1.12}}>{dd2(d.getDate())}</span>
              <span style={{color:sel?"#cfe0ff":"var(--text3)",fontSize:9.5,letterSpacing:"0.06em",textTransform:"uppercase"}}>{sabado ? "ate 13h" : MES_CURTO[d.getMonth()]}</span>
              {st && <span style={{background:sel?"#fff":cor,borderRadius:2,bottom:5,height:2.5,left:12,opacity:sel?.85:.9,position:"absolute",right:12}} />}
              {st && (
                <span style={{background:cor,border:"1px solid "+comAlfa(cor,.75),borderRadius:9,color:"#fff",fontSize:9.5,fontWeight:800,padding:"1px 6px",position:"absolute",right:-6,top:-7}}>{st.qtd}</span>
              )}
              {st && st.atrasado && (
                <span title="Parado ha mais de 48h" style={{alignItems:"center",background:"#ef4444",borderRadius:"50%",boxShadow:"0 0 10px 1px rgba(239,68,68,.7)",color:"#fff",display:"flex",fontSize:9,fontWeight:800,height:15,justifyContent:"center",left:-6,position:"absolute",top:-7,width:15}}>!</span>
              )}
            </button>
          );
        })}
      </div>

      {/* agenda do dia, em cascata */}
      {dia && ags.length > 0 && (
        <div style={{display:"flex",flexDirection:"column",gap:6}}>
          <div style={{alignItems:"center",color:"var(--text3)",display:"flex",fontSize:10,fontWeight:700,gap:8,letterSpacing:"0.14em",textTransform:"uppercase"}}>
            {t("agendamentos.ja_agendado", "Ja agendado neste dia")}
            <span style={{background:"var(--border)",flex:1,height:1}} />
          </div>
          {ags.slice(0, 4).map((a, i) => {
            const et = ETAPAS.find(e => e.key === a.status) || ETAPAS[0];
            const parado = ETAPAS_COM_ALERTA_PARADO.includes(a.status) && horasParado(a) >= HORAS_PARA_ALERTA;
            const c = parado ? "#ef4444" : et.cor;
            return (
              <div key={a.id} className="sdh-linha" style={{"--i": i, alignItems:"center",background:"rgba(26,32,53,.55)",border:"1px solid rgba(120,146,196,.22)",borderLeft:"3px solid "+c,borderRadius:9,display:"flex",gap:11,padding:"8px 12px"}}>
                <span style={{fontSize:14,fontWeight:800,minWidth:47}}>{horaParteDe(a.data_agendamento) || "--:--"}</span>
                <span style={{flex:1,fontSize:13,fontWeight:600,minWidth:0,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{a.cliente_nome}{a.veiculo ? " \u00b7 " + a.veiculo : ""}</span>
                <span style={{background:comAlfa(c,.16),border:"1px solid "+comAlfa(c,.4),borderRadius:20,color:c,fontSize:9.5,fontWeight:800,letterSpacing:"0.07em",padding:"2px 9px",textTransform:"uppercase",whiteSpace:"nowrap"}}>{parado ? t("agendamentos.parado", "Parado") : et.label}</span>
              </div>
            );
          })}
          {ags.length > 4 && (
            <div className="sdh-linha" style={{"--i": 4, background:"rgba(26,32,53,.55)",border:"1px solid rgba(120,146,196,.22)",borderLeft:"3px solid var(--border2)",borderRadius:9,color:"var(--text3)",fontSize:13,padding:"8px 12px"}}>
              + {ags.length - 4} {t("agendamentos.outros_neste_dia", "outro(s) neste dia")}
            </div>
          )}
        </div>
      )}

      {/* horarios */}
      {!dia ? (
        <div style={{border:"1px dashed var(--border)",borderRadius:10,color:"var(--text3)",fontSize:13,padding:"24px 12px",textAlign:"center"}}>
          {t("agendamentos.escolha_dia", "Escolha um dia para ver os horarios")}
        </div>
      ) : (
        <div style={{display:"flex",flexDirection:"column",gap:14,minWidth:0}}>
          {blocos.map(([rot, arr]) => (
            <div key={rot} style={{display:"flex",flexDirection:"column",gap:8}}>
              <div style={{alignItems:"center",color:"var(--text3)",display:"flex",fontSize:10,fontWeight:700,gap:8,letterSpacing:"0.14em",textTransform:"uppercase"}}>
                {rot}<span style={{background:"var(--border)",flex:1,height:1}} />
              </div>
              <div style={{display:"grid",gap:7,gridTemplateColumns:"repeat(auto-fill,minmax(74px,1fr))"}}>
                {arr.map(m => {
                  const hm = hhmmDe(m);
                  const cheio = ocupados.includes(hm);
                  const passou = ehHoje && m < agoraMin;
                  // alguem dentro desta meia hora, mas nao neste minuto
                  const vizinho = !cheio && ocupados.some(o => minDe(o) > m && minDe(o) < m + PASSO_GRADE);
                  return (
                    <button key={hm} type="button" disabled={cheio || passou}
                      className={"sdh-slot" + (hora === hm ? " on" : "")}
                      style={{"--i": idx++}}
                      onClick={() => escolherHora(hm)}
                      title={cheio ? t("agendamentos.ja_existe_neste_horario", "Ja existe agendamento neste horario") : (passou ? t("agendamentos.horario_passou", "Horario ja passou") : (vizinho ? t("agendamentos.alguem_na_meia_hora", "Livre -- mas ha agendamento dentro desta meia hora") : hm))}>
                      {hm}
                      {vizinho && <span style={{background:"#f59e0b",borderRadius:"50%",height:4,position:"absolute",right:4,top:4,width:4}} />}
                    </button>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* ajuste fino de 5 em 5 */}
      {dia && hora && (() => {
        const m = minDe(hora);
        const bate = ocupados.includes(hora);
        const menos = dentroExpediente(dia, m - PASSO_FINO);
        const mais = dentroExpediente(dia, m + PASSO_FINO);
        return (
          <div style={{alignItems:"center",background:"rgba(26,32,53,.6)",border:"1px solid rgba(120,146,196,.22)",borderRadius:11,display:"flex",flexWrap:"wrap",gap:12,padding:"11px 14px"}}>
            <span style={{color:"var(--text3)",fontSize:9.5,fontWeight:700,letterSpacing:"0.13em",textTransform:"uppercase"}}>{t("agendamentos.ajuste_fino", "Ajuste fino")}</span>
            <span style={{alignItems:"center",display:"flex",gap:9}}>
              <button type="button" className="sdh-step" disabled={!menos} onClick={() => escolherHora(hhmmDe(m - PASSO_FINO))}>&minus; 5 min</button>
              <span style={{color:bate?"#ef4444":undefined,fontSize:22,fontWeight:800,minWidth:74,textAlign:"center"}}>{hora}</span>
              <button type="button" className="sdh-step" disabled={!mais} onClick={() => escolherHora(hhmmDe(m + PASSO_FINO))}>+ 5 min</button>
            </span>
            <span style={{color:bate?"#ef4444":"var(--text3)",fontSize:11.5,fontWeight:bate?700:400,marginLeft:"auto"}}>
              {bate ? t("agendamentos.choque_horario", "Ja existe agendamento neste horario") : t("agendamentos.mexe_5_em_5", "Mexe de 5 em 5 dentro do expediente")}
            </span>
          </div>
        );
      })()}

      {/* resumo */}
      <div style={{alignItems:"center",background:"rgba(26,32,53,.6)",border:"1px solid rgba(120,146,196,.22)",borderLeft:"3px solid var(--accent2)",borderRadius:11,display:"flex",flexWrap:"wrap",gap:12,padding:"12px 15px"}}>
        <span aria-hidden="true" style={{fontSize:19,lineHeight:1}}>{dia && hora ? "\u2713" : "\ud83d\uddd3"}</span>
        <span style={{display:"flex",flexDirection:"column",gap:1,minWidth:0}}>
          <span style={{color:"var(--text3)",fontSize:9.5,fontWeight:700,letterSpacing:"0.13em",textTransform:"uppercase"}}>
            {dia && hora ? t("agendamentos.agendado_para", "Agendado para") : t("agendamentos.selecao", "Selecao")}
          </span>
          <span style={{color:(dia && hora)?undefined:"var(--text3)",fontSize:(dia && hora)?15.5:13.5,fontWeight:(dia && hora)?700:500}}>
            {dia && hora
              ? DOW_CURTO[dia.getDay()] + ", " + dd2(dia.getDate()) + "/" + dd2(dia.getMonth() + 1) + "/" + dia.getFullYear() + " \u00e0s " + hora
              : (dia
                  ? DOW_CURTO[dia.getDay()] + ", " + dd2(dia.getDate()) + "/" + dd2(dia.getMonth() + 1) + " \u2014 " + t("agendamentos.falta_horario", "falta o horario")
                  : t("agendamentos.nenhuma_data", "Nenhuma data escolhida"))}
          </span>
        </span>
      </div>
    </div>
  );
}

// Exibicao de data/hora do agendamento. Le a string local sem fuso e
// mostra dd/mm/aaaa hh:mm. Usada no card e no modal de detalhe.
function exibirDataHoraAg(valor) {
  if (!valor) return "";
  try {
    const d = new Date(valor);
    if (Number.isNaN(d.getTime())) return "";
    const p = (n) => String(n).padStart(2, "0");
    return p(d.getDate()) + "/" + p(d.getMonth() + 1) + "/" + d.getFullYear() +
           " " + p(d.getHours()) + ":" + p(d.getMinutes());
  } catch { return ""; }
}

function CardAg({ ag, onClick }) {
  const etapa = ETAPAS.find(e => e.key === ag.status) || ETAPAS[0];
  const parado = ETAPAS_COM_ALERTA_PARADO.includes(ag.status) && horasParado(ag) >= HORAS_PARA_ALERTA;
  return (
    <div onClick={onClick} className={parado ? "card-ag-piscando" : ""} style={{background:"var(--bg3)",border:"1px solid " + (parado ? "#ef4444" : "var(--border)"),borderRadius:8,cursor:"pointer",marginBottom:8,padding:12,position:"relative"}}
      onMouseOver={e=>{ if(!parado) e.currentTarget.style.borderColor=etapa.cor; }}
      onMouseOut={e=>{ if(!parado) e.currentTarget.style.borderColor="var(--border)"; }}>
      {parado && (
        <div title={`Parado ha mais de ${HORAS_PARA_ALERTA}h sem resposta do cliente`} style={{
          position:"absolute", top:-8, right:-8, background:"#ef4444", color:"#fff", fontSize:9, fontWeight:800,
          borderRadius:99, padding:"2px 7px", display:"flex", alignItems:"center", gap:3, boxShadow:"0 2px 8px #ef444488",
        }}>⏰ PARADO</div>
      )}
      <div style={{color:etapa.cor,fontFamily:"monospace",fontSize:11,marginBottom:4}}>{ag.id}</div>
      <div style={{fontSize:13,fontWeight:600,marginBottom:2}}>{ag.cliente_nome}</div>
      <div style={{color:"var(--text2)",fontSize:11,marginBottom:4}}>{ag.telefone}</div>
      {ag.data_agendamento && (
        <div style={{alignItems:"center",background:"rgba(79,140,255,0.15)",border:"1px solid rgba(79,140,255,0.45)",borderRadius:6,boxShadow:"0 0 12px -5px rgba(79,140,255,0.9)",color:"#9DC0FF",display:"inline-flex",fontSize:11,fontWeight:800,gap:5,letterSpacing:"0.02em",marginBottom:6,padding:"3px 8px"}}>
          <span aria-hidden="true">🗓</span>{exibirDataHoraAg(ag.data_agendamento)}
        </div>
      )}
      {ag.placa && <div style={{color:"var(--text3)",fontFamily:"monospace",fontSize:11}}>{ag.placa} {ag.veiculo ? "· "+ag.veiculo : ""}</div>}
      {ag.orcamento_total > 0 && <div style={{color:"var(--green)",fontSize:12,fontWeight:600,marginTop:6}}>R$ {Number(ag.orcamento_total).toFixed(2)}</div>}
      {ag.os_id && <div style={{color:"#3b82f6",fontSize:10,marginTop:4}}>OS: {ag.os_id}</div>}
    </div>
  );
}

export default function Agendamentos() {
  const { t } = useTranslation();
  // AUD-E: t() sensivel ao segmento. Usado SO nas chamadas de
  // vocabulario de veiculo; o resto da tela segue no t() de sempre.
  const { tSeg } = useTextosSegmento();
  const navigate = useNavigate();
  const fetchGen = useRef(0);
  const tenantId = getTenantIdFromToken() || "1";
  const tk = () => (sessionStorage.getItem("access_token")||localStorage.getItem("access_token")) || "";

  const [lista, setLista] = useState([]);
  const [_featuresBackend, setFeaturesBackend] = useState(()=>{try{const tid=getTenantIdFromToken()||"1";return JSON.parse(localStorage.getItem("dev_features_liberadas_tenant_"+tid)||"[]");}catch{return[];}});
  useEffect(()=>{const tid=getTenantIdFromToken()||"1";authFetch("/api/v1/config/features_liberadas_tenant_"+tid).then(r=>r.ok?r.json():null).then(d=>{if(d&&d.value&&d.value.features){setFeaturesBackend(d.value.features);localStorage.setItem("dev_features_liberadas_tenant_"+tid,JSON.stringify(d.value.features));}}).catch(()=>{});},[]);
  const planoAtual = ((sessionStorage.getItem("plano")||localStorage.getItem("plano"))||"basico").toLowerCase();
  const modelosDisponiveis = ["basico", ...(_featuresBackend.includes("orcamento_profissional")||planoAtual==="premium"?["profissional"]:[]), ...(_featuresBackend.includes("orcamento_premium")||planoAtual==="premium"?["premium"]:[])];
  const [clientes, setClientes] = useState([]);
  const [modalNovo, setModalNovo] = useState(() => {
    try {
      if (!localStorage.getItem("agendamento_prefill")) return false;
      // Pedido de PRE-ORCAMENTO nao abre o formulario de solicitacao: o
      // documento abre direto (ver o efeito "pre-orcamento direto" abaixo).
      return !localStorage.getItem("agendamento_abrir_pre");
    } catch { return false; }
  });
  const [modalDetalhe, setModalDetalhe] = useState(null);
  // Marca deixada pelo Clientes.js quando o usuario pediu PRE-ORCAMENTO a
  // partir do cadastro. Lida uma vez e removida na hora: se ele desistir,
  // nao fica guardada para disparar depois.
  const [abrirPreAoSalvar, setAbrirPreAoSalvar] = useState(() => {
    try {
      if (localStorage.getItem("agendamento_abrir_pre")) {
        localStorage.removeItem("agendamento_abrir_pre");
        return true;
      }
    } catch {}
    return false;
  });
  // C+ : edicao de agendamento ja criado (pedido da cliente).
  // Guarda uma COPIA do registro; o original so muda depois do POST dar certo.
  const [modalEditar, setModalEditar] = useState(null);
  const [salvandoEdicao, setSalvandoEdicao] = useState(false);
  // Linha do tempo de status do agendamento aberto (ver GET
  // /agendamentos/{tenant_id}/{id}/historico em dados.py) -- pedido do
  // Abima de 31/08/2026: registrar data/hora de cada etapa realizada.
  const [historicoAg, setHistoricoAg] = useState([]);
  useEffect(() => {
    if (!modalDetalhe?.id) { setHistoricoAg([]); return; }
    authFetch("/api/v1/dados/agendamentos/" + tenantId + "/" + modalDetalhe.id + "/historico")
      .then(r => r.ok ? r.json() : [])
      .then(d => setHistoricoAg(Array.isArray(d) ? d : []))
      .catch(() => setHistoricoAg([]));
  }, [modalDetalhe?.id]);
  // Dados institucionais da oficina -- mesma chave que ja alimenta o
  // cabecalho do PDF do orcamento (ver OrcamentoDetalhe.js). Se falhar, a
  // mensagem sai sem o bloco da oficina; nada quebra.
  const [oficinaCfg, setOficinaCfg] = useState(null);
  useEffect(() => {
    authFetch(API_BASE + "/api/v1/config/orcamento_config_tenant_" + tenantId)
      .then(r => r.ok ? r.json() : null)
      .then(d => setOficinaCfg((d && d.value) || null))
      .catch(() => setOficinaCfg(null));
  }, []);

  // Payload do evento -- a entidade crua nao atravessa para o modulo de
  // mensagens. A data ja vai formatada: formatar e responsabilidade desta
  // tela, montar texto e responsabilidade de services/mensagens.js.
  const payloadAgendamento = (ag) => ({
    clienteNome: ag.cliente_nome,
    telefone: ag.telefone,
    dataHoraTexto: exibirDataHoraAg(ag.data_agendamento),
    veiculo: ag.veiculo,
    placa: ag.placa,
    servico: ag.servico_solicitado
  });

  // Pre-orcamento: SOMENTE nome, quantidade e PRECO FINAL de cada item.
  // O item gravado pode carregar custoUnit/margem; este map e a segunda
  // barreira (a primeira esta nos moldes de mensagens.js) para garantir que
  // custo e lucro nunca atravessem para o texto que o cliente le.
  const payloadOrcamento = (ag) => ({
    ...payloadAgendamento(ag),
    itens: (ag.orcamento && Array.isArray(ag.orcamento.itens) ? ag.orcamento.itens : [])
      .map((i) => ({ nome: i.nome, qtd: i.qtd, preco: i.preco })),
    total: Number(ag.orcamento_total) || 0
  });

  const [modalOrc, setModalOrc] = useState(null);
  const [itensOrc, setItensOrc] = useState([]);
  const [modeloOrcAg, setModeloOrcAg] = useState("basico");
  const [buscaCliente, setBuscaCliente] = useState("");
  const [filtroGeral, setFiltroGeral] = useState("");
  const [filtroStatus, setFiltroStatus] = useState("");

  const formVazio = { cliente_nome:"", telefone:"", cpf:"", email:"", veiculo:"", placa:"", km:"", servico_solicitado:"", relato_cliente:"", observacoes:"", data_agendamento:"", cliente_id:null };
  const [form, setForm] = useState(() => {
    try {
      const p = localStorage.getItem("agendamento_prefill");
      if (p) { localStorage.removeItem("agendamento_prefill"); return { ...formVazio, ...JSON.parse(p) }; }
    } catch {}
    return formVazio;
  });

  // ---- Pre-orcamento direto -------------------------------------------
  // Veio do botao PRE-ORCAMENTO do cadastro de clientes. Cria a solicitacao
  // em silencio -- sem data, fila de espera -- e abre o documento na hora.
  // E exatamente o registro que o fluxo antigo criava; o que sai e o passo
  // de preencher o formulario de agendamento para so entao ver o
  // pre-orcamento. Roda uma vez: preCriado trava qualquer repeticao.
  const preCriado = useRef(false);
  useEffect(() => {
    if (!abrirPreAoSalvar || preCriado.current) return;
    if (!form.cliente_nome || !form.telefone) return;
    preCriado.current = true;
    (async () => {
      const res = await salvarAg({
        ...form,
        status: "solicitacao",
        criada: new Date().toLocaleString("pt-BR"),
        placa: (form.placa || "").toUpperCase(),
        data_agendamento: null,
      });
      if (res && res.id) {
        setAbrirPreAoSalvar(false);
        setModalNovo(false);
        setItensOrc([]);
        setModalOrc({ ...form, id: res.id, status: "solicitacao", data_agendamento: null });
      } else {
        // Nao deu para criar o registro. Em vez de deixar a pessoa sem nada,
        // volta ao caminho antigo: abre o formulario e mantem a marca, para
        // que o pre-orcamento ainda apareca depois de salvar a solicitacao.
        setModalNovo(true);
        window.alert(t(
          "agendamentos.pre_falhou",
          "Nao foi possivel abrir o pre-orcamento agora. Registre a solicitacao e tente de novo."
        ));
      }
    })();
  }, [abrirPreAoSalvar, form]);
  // ----------------------------------------------------------------------

  const carregar = () => {
    const gen = ++fetchGen.current;
    authFetch("/api/v1/dados/agendamentos/" + tenantId, { headers: { } })
      .then(r => r.ok ? r.json() : [])
      .then(d => { if (Array.isArray(d) && gen === fetchGen.current) setLista(d); })
      .catch(() => {});
    authFetch("/api/v1/dados/clientes/" + tenantId, { headers: { } })
      .then(r => r.ok ? r.json() : [])
      .then(d => { if (Array.isArray(d)) setClientes(d); })
      .catch(() => {});
  };

  useEffect(() => { carregar(); }, [tenantId]);

  // Forca um re-render periodico so pra recalcular "horasParado" mesmo se
  // ninguem tocar em nada na tela -- senao o alerta piscante de card parado
  // (ver ETAPAS_COM_ALERTA_PARADO) so apareceria depois de um F5 manual.
  const [, forcarRecalculo] = useState(0);
  useEffect(() => {
    const iv = setInterval(() => forcarRecalculo(x => x + 1), 5 * 60 * 1000);
    return () => clearInterval(iv);
  }, []);

  const salvarAg = async (payload) => {
    try {
      console.log("[salvarAg] POST", "/api/v1/dados/agendamentos/"+tenantId, payload);
      const r = await authFetch("/api/v1/dados/agendamentos/" + tenantId, {
        method: "POST", headers: { "Content-Type": "application/json", },
        body: JSON.stringify(payload),
      });
      console.log("[salvarAg] Response:", r.status, r.ok);
      if (r.ok) { fetchGen.current++; carregar(); return await r.json(); }
      const err = await r.text();
      console.error("[salvarAg] Erro:", err);
    } catch(e) { console.error("[salvarAg] Exception:", e); }
    return null;
  };

  const mudarStatus = async (ag, novoStatus) => {
    await authFetch("/api/v1/dados/agendamentos/" + tenantId + "/" + ag.id + "/status", {
      method: "PATCH", headers: { "Content-Type": "application/json", },
      body: JSON.stringify({ status: novoStatus }),
    });
    // Recarregar do banco para garantir dados completos
    fetchGen.current++;
    await carregar();
    if (modalDetalhe?.id === ag.id) setModalDetalhe(d => ({ ...d, status: novoStatus }));
  };

  const criarSolicitacao = async () => {
    if (!form.cliente_nome || !form.telefone) return;
    // O SeletorDataHora entrega "AAAA-MM-DDTHH:mm" no horario de quem
    // digitou. Gravamos assim, SEM fuso, igual ao paraISO() e ao salvarEdicao.
    const dtNova = form.data_agendamento
      ? (form.data_agendamento.length === 16 ? form.data_agendamento + ":00" : form.data_agendamento)
      : null;
    const res = await salvarAg({
      ...form, status: "solicitacao",
      criada: new Date().toLocaleString("pt-BR"),
      placa: (form.placa || "").toUpperCase(),
      data_agendamento: dtNova,
    });
    if (res?.id) {
      adicionarNotificacao("nova_os", "Nova solicitacao", res.id + " - " + form.cliente_nome, res.id);
      // Veio do botao PRE-ORCAMENTO do cadastro de clientes: emenda direto
      // no documento, sem obrigar a procurar o card recem-criado no quadro.
      // O objeto e montado do form + id, porque a lista so recarrega depois.
      if (abrirPreAoSalvar) {
        setAbrirPreAoSalvar(false);
        setItensOrc([]);
        setModalOrc({ ...form, id: res.id, status: "solicitacao", data_agendamento: dtNova });
      }
      setForm(formVazio);
      setModalNovo(false);
    }
  };

  const registrarPreCadastro = async (ag) => {
    await salvarAg({ ...ag, status: "pre_cadastro", placa: (ag.placa || "").toUpperCase() });
    setModalDetalhe(null);
  };

  // A resposta do servidor passa a ser lida. O backend recusa com 409 uma
  // gravacao que esvaziaria um orcamento que tem itens (trava de 14/09) e
  // manda a explicacao em `detail` -- e isso que aparece para o usuario.
  const erroDoServidor = async (r) => {
    if (r && r.ok) return null;
    let msg = "";
    try { const e = await r.json(); if (e && e.detail) msg = String(e.detail); } catch {}
    return msg || t("agendamentos.orc_falhou", "Nao foi possivel salvar o orcamento. Tente novamente.");
  };

  const enviarOrcamento = async () => {
    if (!modalOrc) return;
    const total = itensOrc.reduce((a, i) => a + (Number(i.preco) || 0), 0);
    const r = await authFetch("/api/v1/dados/agendamentos/" + tenantId + "/" + modalOrc.id + "/orcamento", {
      method: "PATCH", headers: { "Content-Type": "application/json", },
      body: JSON.stringify({ orcamento: { itens: itensOrc, total }, orcamento_total: total, status: "orcamento_enviado" }),
    });
    // Nao salvou: o modal fica aberto (nada do que foi digitado se perde) e
    // a notificacao de envio NAO dispara.
    const falha = await erroDoServidor(r);
    if (falha) { window.alert(falha); return; }
    fetchGen.current++;
    carregar();
    setModalOrc(null);
    setModalDetalhe(null);
    adicionarNotificacao("aprovacao", "Orcamento enviado", modalOrc.id + " - aguardando confirmacao do cliente", modalOrc.id);
  };

  const confirmarCliente = async (ag) => {
    await mudarStatus(ag, "confirmado");
    adicionarNotificacao("status", "Agendamento confirmado", ag.id + " - " + ag.cliente_nome + " confirmou", ag.id);
  };

  const converterOS = async (ag) => {
    const r = await authFetch("/api/v1/dados/agendamentos/" + tenantId + "/" + ag.id + "/converter-os", {
      method: "POST", headers: { },
    });
    if (r.ok) {
      const data = await r.json();
      fetchGen.current++;
      carregar();
      setModalDetalhe(null);
      adicionarNotificacao("nova_os", "OS criada do agendamento", data.id + " - " + ag.cliente_nome, data.id);
      if (window.confirm(t("agendamentos.confirm_os_criada",{id:data.id}))) navigate("/os");
    }
  };

  // ---------------------------------------------------------------------
  // EDITAR AGENDAMENTO
  // Reaproveita salvarAg (POST). O backend ja trata POST com id existente
  // como UPDATE -- e o mesmo caminho que registrarPreCadastro usa hoje em
  // producao, entao nao ha rota nova nem comportamento novo no servidor.
  // ---------------------------------------------------------------------
  const paraCampoDataHora = (valor) => {
    if (!valor) return "";
    try {
      const d = new Date(valor);
      if (Number.isNaN(d.getTime())) return "";
      const p = (n) => String(n).padStart(2, "0");
      return d.getFullYear() + "-" + p(d.getMonth() + 1) + "-" + p(d.getDate()) +
             "T" + p(d.getHours()) + ":" + p(d.getMinutes());
    } catch { return ""; }
  };

  const abrirEdicao = (ag) => {
    if (!ag) return;
    setModalEditar({ ...ag, _dataLocal: paraCampoDataHora(ag.data_agendamento) });
  };

  const salvarEdicao = async () => {
    if (!modalEditar || salvandoEdicao) return;
    if (!modalEditar.cliente_nome || !modalEditar.telefone) {
      window.alert(t("agendamentos.edit_obrigatorios", "Nome e telefone sao obrigatorios."));
      return;
    }
    setSalvandoEdicao(true);
    try {
      // _dataLocal e so da tela: nao pode ir para o banco.
      const { _dataLocal, ...registro } = modalEditar;
      // O SeletorDataHora ja entrega "AAAA-MM-DDTHH:mm" no horario
      // de quem digitou. Guardamos exatamente isso, SEM fuso -- e o mesmo
      // formato que paraISO() usa no resto do sistema. Usar toISOString()
      // aqui converteria para UTC e o horario andaria +3h a cada gravacao.
      let iso = null;
      if (_dataLocal) {
        iso = _dataLocal.length === 16 ? _dataLocal + ":00" : _dataLocal;
      }
      // O espalhamento vem PRIMEIRO: id, status, os_id, orcamento e historico
      // sobrevivem intactos. So os campos abaixo sao reescritos.
      const payload = {
        ...registro,
        placa: (registro.placa || "").toUpperCase(),
        data_agendamento: iso,
      };
      const res = await salvarAg(payload);
      if (!res || !res.id) {
        window.alert(t("agendamentos.edit_falhou", "Nao foi possivel salvar as alteracoes. Tente novamente."));
        return; // modal continua aberto, nada digitado se perde
      }
      fetchGen.current++;
      await carregar();
      setModalEditar(null);
      setModalDetalhe(null);
    } finally {
      setSalvandoEdicao(false);
    }
  };

  const cancelar = async (ag) => {
    if (!window.confirm(t("agendamentos.confirm_cancelar"))) return;
    await mudarStatus(ag, "cancelado");
    setModalDetalhe(null);
  };

  const ativos = lista.filter(a => {
    if(a.status === "cancelado") return false;
    if(filtroStatus && a.status !== filtroStatus) return false;
    if(filtroGeral){
      const q = filtroGeral.toLowerCase();
      // Com o telefone mascarado, procurar por texto cru nao acha nada:
      // quem digita "11978" nao casa com "(11) 97845-6859". Digito com digito.
      const qd = soDigitos(filtroGeral);
      return (a.cliente_nome||"").toLowerCase().includes(q)||
             (!!qd && soDigitos(a.telefone||"").includes(qd))||
             (a.placa||"").toLowerCase().includes(q)||
             (a.id||"").toLowerCase().includes(q);
    }
    return true;
  });
  // fmt() escolhe a mascara pelo NOME do campo: telefone, cpf/cnpj, placa,
  // nome em caixa alta, km so digitos. E-mail fica intocado de proposito.
  const upd = (c, v) => setForm(f => ({ ...f, [c]: fmt(c, v) }));

  return (
    <Layout>
      <style>{`
        @keyframes ag-card-blink {
          0%, 100% { box-shadow: 0 0 0 0 rgba(239,68,68,0.55); }
          50% { box-shadow: 0 0 0 5px rgba(239,68,68,0); }
        }
        @keyframes ag-dot-blink { 0%, 100% { opacity: 1; } 50% { opacity: 0.25; } }
        .card-ag-piscando { animation: ag-card-blink 1.6s ease-in-out infinite; }
        .ag-col-alerta-dot { animation: ag-dot-blink 1.1s ease-in-out infinite; }
      `}</style>
      <div style={{display:"flex",flexDirection:"column",gap:20}}>
        <div style={{alignItems:"flex-start",display:"flex",justifyContent:"space-between"}}>
          <div>
            <div style={{alignItems:"center",display:"flex",gap:8}}><h1 style={{fontSize:22,fontWeight:700}}>{t("agendamentos.titulo")}</h1><BotaoDica id="agendamentos" /></div>
            <p style={{color:"var(--text2)",fontSize:13,marginTop:3}}>{t("agendamentos.subtitulo")}</p>
          </div>
          <button className="btn-primary" onClick={()=>setModalNovo(true)} style={{fontSize:13,padding:"10px 18px"}}>{t("agendamentos.nova_solicitacao")}</button>
        </div>

        <Dica id="agendamentos" jaUsou={lista.length > 0} texto={t("dicas.agendamentos")} />

        <div style={{display:"flex",gap:10,flexWrap:"wrap",marginBottom:4}}>
          <input placeholder={t("agendamentos.buscar_placeholder")}
            value={filtroGeral} onChange={e=>setFiltroGeral(e.target.value)}
            style={{background:"var(--bg3)",border:"1px solid var(--border)",borderRadius:8,color:"var(--text)",fontSize:13,padding:"8px 14px",flex:1,minWidth:200}}
          />
          <select value={filtroStatus} onChange={e=>setFiltroStatus(e.target.value)}
            style={{background:"var(--bg3)",border:"1px solid var(--border)",borderRadius:8,color:"var(--text)",fontSize:13,padding:"8px 14px"}}>
            <option value="">{t("agendamentos.todos_status")}</option>
            {ETAPAS.map(e=><option key={e.key} value={e.key}>{t(`agendamentos.etapa_${e.key}`)}</option>)}
          </select>
        </div>
        <div style={{display:"flex",flexWrap:"wrap",gap:12,paddingBottom:8}}>
          {ETAPAS.map(etapa => {
            const items = ativos.filter(a => a.status === etapa.key);
            const temParado = ETAPAS_COM_ALERTA_PARADO.includes(etapa.key) && items.some(a => horasParado(a) >= HORAS_PARA_ALERTA);
            return (
              <div key={etapa.key} style={{background:"var(--bg3)",border:"1px solid " + (temParado ? "#ef444455" : "var(--border)"),borderRadius:10,flex:"1 1 180px",minWidth:170,maxWidth:260,padding:12}}>
                <div style={{alignItems:"center",display:"flex",gap:6,marginBottom:12}}>
                  <div style={{background:etapa.cor,borderRadius:99,height:8,width:8}} />
                  <span style={{color:etapa.cor,fontSize:11,fontWeight:700}}>{t(`agendamentos.etapa_${etapa.key}`)}</span>
                  {temParado && <span className="ag-col-alerta-dot" title={`Tem agendamento parado ha mais de ${HORAS_PARA_ALERTA}h`} style={{fontSize:12}}>⏰</span>}
                  <span style={{background:etapa.bg,borderRadius:99,color:etapa.cor,fontSize:10,fontWeight:700,marginLeft:"auto",padding:"1px 8px"}}>{items.length}</span>
                </div>
                {items.map(ag => <CardAg key={ag.id} ag={ag} onClick={()=>setModalDetalhe(ag)} />)}
              </div>
            );
          })}
        </div>
      </div>

      {modalNovo && (
        <Modal onClose={()=>setModalNovo(false)} largura={560}>
          <div style={{alignItems:"center",display:"flex",justifyContent:"space-between",marginBottom:20}}>
            <div>
              <div style={{color:"var(--accent2)",fontSize:12,marginBottom:4}}>{t("agendamentos.fila_espera")}</div>
              <div style={{fontSize:18,fontWeight:800}}>{t("agendamentos.modal_novo_titulo")}</div>
            </div>
            <BtnFechar onClick={()=>setModalNovo(false)} />
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:12}}>
            {/* Data e hora do agendamento -- o formulario de producao tinha o
                campo data_agendamento no estado, mas nenhum input para ele:
                nao havia como marcar quando o cliente viria. Mesmo destaque
                visual do modal de edicao, para os dois lerem igual. */}
            <SeletorDataHora
              valor={form.data_agendamento || ""}
              aoMudar={v=>setForm(f=>({...f,data_agendamento:v}))}
              agendamentos={lista}
              idIgnorar={null}
              t={t}
            />
            <div style={{position:"relative"}}>
              <label style={{color:"var(--text2)",display:"block",fontSize:11,fontWeight:600,marginBottom:4}}>{t("agendamentos.buscar_cliente_cadastrado")}</label>
              <input
                placeholder={t("agendamentos.buscar_cliente_placeholder")}
                value={buscaCliente}
                onChange={e=>{setBuscaCliente(e.target.value);}}
                style={{width:"100%"}}
              />
              {buscaCliente.length>1 && (
                <div style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:8,boxShadow:"0 4px 20px #0004",left:0,maxHeight:200,overflowY:"auto",position:"absolute",right:0,top:"100%",zIndex:100}}>
                  {clientes.filter(c=>
                    c.nome?.toLowerCase().includes(buscaCliente.toLowerCase())||
                    (!!soDigitos(buscaCliente) && soDigitos(c.telefone||"").includes(soDigitos(buscaCliente)))||
                    (!!soDigitos(buscaCliente) && soDigitos(c.cpf||"").includes(soDigitos(buscaCliente)))
                  ).slice(0,6).map(c=>(
                    <div key={c.id} onClick={()=>{
                      // Escolher o cliente traz o VEICULO junto. Sem isto a atendente
                      // digitava placa, modelo e km de novo -- dado que ja estava no
                      // cadastro -- e qualquer divergencia de digitacao quebrava o
                      // vinculo entre agendamento, OS e orcamento (comparados por placa).
                      // Cliente com mais de um veiculo traz o primeiro; os demais
                      // continuam editaveis a mao nos campos abaixo.
                      setForm(f=>{
                        const v = (c.veiculos || [])[0] || {};
                        return {...f, cliente_id:c.id, cliente_nome:c.nome, telefone:c.telefone,
                          cpf:c.cpf||"", email:c.email||"",
                          placa: v.placa || f.placa || "",
                          veiculo: v.modelo || f.veiculo || "",
                          km: v.km || f.km || ""};
                      });
                      setBuscaCliente(c.nome);
                    }} style={{borderBottom:"1px solid var(--border)",cursor:"pointer",padding:"10px 14px"}}
                    onMouseOver={e=>e.currentTarget.style.background="var(--bg3)"}
                    onMouseOut={e=>e.currentTarget.style.background="transparent"}>
                      <div style={{fontSize:13,fontWeight:600}}>{c.nome}</div>
                      <div style={{color:"var(--text3)",fontSize:11}}>{c.telefone} {c.cpf?" · "+c.cpf:""}</div>
                    </div>
                  ))}

                </div>
              )}
            </div>
            {[["cliente_nome",t("agendamentos.nome")],["telefone",t("agendamentos.telefone")],["cpf",t("agendamentos.cpf_cnpj")],["email",t("agendamentos.email")],["placa",t("agendamentos.placa")],["veiculo",tSeg("agendamentos.veiculo")],["km",t("agendamentos.km")],["servico_solicitado",t("agendamentos.servico_solicitado")],["relato_cliente",t("agendamentos.relato_cliente")]].map(([campo,label])=>(
              <div key={campo}>
                <label style={{color:"var(--text2)",display:"block",fontSize:11,fontWeight:600,marginBottom:4,textTransform:"uppercase"}}>{label}</label>
                <input value={form[campo]||""} onChange={e=>upd(campo,e.target.value)} style={{width:"100%"}} />
              </div>
            ))}
            <div style={{display:"flex",gap:10,marginTop:8}}>
              <button className="btn-ghost" onClick={()=>setModalNovo(false)} style={{flex:1}}>{t("common.cancelar")}</button>
              <button className="btn-primary" onClick={criarSolicitacao} style={{flex:1}}>{t("agendamentos.registrar_solicitacao")}</button>
            </div>
          </div>
        </Modal>
      )}

      {modalDetalhe && (
        <Modal onClose={()=>setModalDetalhe(null)} largura={620}>
          <div style={{alignItems:"center",display:"flex",justifyContent:"space-between",marginBottom:16}}>
            <div>
              <div style={{color:"var(--accent2)",fontFamily:"monospace",fontSize:12}}>{modalDetalhe.id}</div>
              <div style={{fontSize:18,fontWeight:800}}>{modalDetalhe.cliente_nome}</div>
            </div>
            <BtnFechar onClick={()=>setModalDetalhe(null)} />
          </div>
          {modalDetalhe.data_agendamento && (
            <div style={{alignItems:"center",background:"linear-gradient(135deg, rgba(37,99,235,0.24), rgba(139,92,246,0.14))",border:"1px solid rgba(79,140,255,0.55)",borderRadius:10,boxShadow:"0 0 20px -7px rgba(79,140,255,0.9)",display:"flex",gap:12,marginBottom:12,padding:"12px 14px"}}>
              <span aria-hidden="true" style={{fontSize:22,lineHeight:1}}>🗓</span>
              <div>
                <div style={{color:"var(--text3)",fontSize:10,fontWeight:700,letterSpacing:"0.07em",textTransform:"uppercase"}}>{t("agendamentos.data_hora","Data e hora")}</div>
                <div style={{fontSize:17,fontWeight:800,letterSpacing:"0.02em"}}>{exibirDataHoraAg(modalDetalhe.data_agendamento)}</div>
              </div>
            </div>
          )}
          {/* COMUNICACAO COM O CLIENTE
              Um painel por EVENTO, nao um botao por tela.

              Sem data marcada o evento e "solicitacao recebida"; com data, e
              a confirmacao. Antes, a tela escondia tudo quando nao havia data
              -- tratar "sem hora" como "sem comunicacao" era modelar por
              entidade em vez de por evento, e deixava o cliente sem resposta
              justamente no momento em que ele acabou de pedir atendimento.

              O pre-orcamento aparece assim que existe orcamento montado.

              Telefone invalido, previa, edicao do texto, modelo proprio da
              oficina e escolha de canal ficam todos dentro do painel -- ver
              components/PainelWhatsApp.jsx. */}
          <PainelWhatsApp
            tipo={modalDetalhe.data_agendamento ? "agendamento_confirmado" : "agendamento_solicitacao"}
            dados={payloadAgendamento(modalDetalhe)}
            oficina={oficinaCfg}
            tenantId={tenantId}
            chave={modalDetalhe.id}
            t={t}
          />

          {modalDetalhe.orcamento && Array.isArray(modalDetalhe.orcamento.itens) && modalDetalhe.orcamento.itens.length > 0 && (
            <PainelWhatsApp
              tipo="pre_orcamento"
              dados={payloadOrcamento(modalDetalhe)}
              oficina={oficinaCfg}
              tenantId={tenantId}
              chave={modalDetalhe.id}
              t={t}
            />
          )}
          <div style={{background:"var(--bg3)",borderRadius:10,display:"grid",gap:10,gridTemplateColumns:"1fr 1fr",marginBottom:16,padding:14}}>
            {[[t("agendamentos.info_telefone"),modalDetalhe.telefone],[t("agendamentos.info_placa"),modalDetalhe.placa||"—"],[tSeg("agendamentos.info_veiculo"),modalDetalhe.veiculo||"—"],[t("agendamentos.info_servico"),modalDetalhe.servico_solicitado||"—"],[t("agendamentos.info_total_orc"),modalDetalhe.orcamento_total>0?"R$ "+Number(modalDetalhe.orcamento_total).toFixed(2):"—"],[t("agendamentos.info_os_vinculada"),modalDetalhe.os_id||"—"]].map(([l,v])=>(
              <div key={l}><div style={{color:"var(--text3)",fontSize:10,fontWeight:700}}>{l}</div><div style={{fontSize:13}}>{v}</div></div>
            ))}
          </div>

          {historicoAg.length > 0 && (
            <div style={{background:"var(--bg3)",border:"1px solid var(--border)",borderRadius:10,marginBottom:16,padding:14}}>
              <div style={{color:"var(--text3)",fontSize:10,fontWeight:700,marginBottom:10,textTransform:"uppercase"}}>Linha do tempo</div>
              <div style={{display:"flex",flexDirection:"column",gap:0}}>
                {historicoAg.map((h,i)=>{
                  const etapaInfo = ETAPAS.find(e=>e.key===h.status);
                  let dataFmt = "—";
                  try { dataFmt = new Date(h.em).toLocaleString("pt-BR"); } catch {}
                  return (
                    <div key={i} style={{display:"flex",gap:10,position:"relative",paddingBottom:i===historicoAg.length-1?0:14}}>
                      <div style={{display:"flex",flexDirection:"column",alignItems:"center",flexShrink:0}}>
                        <div style={{width:9,height:9,borderRadius:"50%",background:etapaInfo?.cor||"var(--text3)",marginTop:3}} />
                        {i!==historicoAg.length-1 && <div style={{width:2,flex:1,background:"var(--border)",marginTop:2}} />}
                      </div>
                      <div style={{paddingBottom:4}}>
                        <div style={{fontSize:12.5,fontWeight:700,color:etapaInfo?.cor||"var(--text)"}}>{etapaInfo?t(`agendamentos.etapa_${h.status}`):h.status}</div>
                        {h.detalhe && <div style={{fontSize:11.5,color:"var(--text2)",marginTop:1}}>{h.detalhe}</div>}
                        <div style={{fontSize:11,color:"var(--text3)",marginTop:1}}>{dataFmt}</div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
            {modalDetalhe.status === "solicitacao" && (
              <button onClick={()=>registrarPreCadastro(modalDetalhe)} style={{background:"#8b5cf6",border:"none",borderRadius:8,color:"#fff",cursor:"pointer",fontSize:12,fontWeight:700,padding:"8px 14px"}}>{t("agendamentos.registrar_pre_cadastro")}</button>
            )}
            {/* Antes este botao sumia assim que o orcamento era enviado, e os
                itens ficavam congelados: para trocar uma peca a oficina tinha
                que cancelar e refazer. Agora ele acompanha o agendamento ate a
                conversao em O.S. */}
            {["solicitacao","pre_cadastro","orcamento_enviado","confirmado"].includes(modalDetalhe.status) && (
              <button onClick={()=>{
                // Orcamento ja aprovado pelo cliente: avisa que mexer nos itens
                // devolve o agendamento para "Orcamento enviado" (o valor mudou,
                // precisa de novo aceite).
                if (modalDetalhe.status === "confirmado" && !window.confirm(t("agendamentos.confirm_editar_aprovado","O cliente ja aprovou este orcamento. Alterar os itens devolve o agendamento para \"Orcamento enviado\", aguardando nova confirmacao. Continuar?"))) return;
                setItensOrc(Array.isArray(modalDetalhe.orcamento?.itens)?modalDetalhe.orcamento.itens:[]);
                setModalOrc(modalDetalhe);
              }} style={{background:"#f59e0b",border:"none",borderRadius:8,color:"#fff",cursor:"pointer",fontSize:12,fontWeight:700,padding:"8px 14px"}}>
                {(modalDetalhe.status === "solicitacao" || modalDetalhe.status === "pre_cadastro")
                  ? t("agendamentos.montar_enviar_orcamento")
                  : t("agendamentos.editar_orcamento","Editar orcamento")}
              </button>
            )}
            {modalDetalhe.status === "orcamento_enviado" && (
              <button onClick={()=>confirmarCliente(modalDetalhe)} style={{background:"#22c55e",border:"none",borderRadius:8,color:"#fff",cursor:"pointer",fontSize:12,fontWeight:700,padding:"8px 14px"}}>{t("agendamentos.cliente_confirmou")}</button>
            )}
            {modalDetalhe.status === "confirmado" && (
              <button onClick={()=>converterOS(modalDetalhe)} style={{background:"#3b82f6",border:"none",borderRadius:8,color:"#fff",cursor:"pointer",fontSize:12,fontWeight:700,padding:"8px 14px"}}>{t("agendamentos.converter_os")}</button>
            )}
            {modalDetalhe.os_id && (
              <button onClick={()=>navigate("/os")} style={{background:"var(--bg4)",border:"1px solid var(--border)",borderRadius:8,color:"var(--text2)",cursor:"pointer",fontSize:12,padding:"8px 14px"}}>{t("agendamentos.ver_em_os")}</button>
            )}
            {modalDetalhe.status !== "convertido_os" && (
              <button onClick={()=>abrirEdicao(modalDetalhe)} style={{background:"#0ea5e9",border:"none",borderRadius:8,color:"#fff",cursor:"pointer",fontSize:12,fontWeight:700,padding:"8px 14px"}}>{t("common.editar","Editar")}</button>
            )}
            {modalDetalhe.status !== "convertido_os" && modalDetalhe.status !== "cancelado" && (
              <button onClick={()=>cancelar(modalDetalhe)} style={{background:"#ef444422",border:"1px solid #ef4444",borderRadius:8,color:"#ef4444",cursor:"pointer",fontSize:12,padding:"8px 14px"}}>{t("common.cancelar")}</button>
            )}
            <button onClick={async()=>{
              if(!window.confirm(t("agendamentos.confirm_excluir"))) return;
              await authFetch("/api/v1/dados/agendamentos/"+tenantId+"/"+modalDetalhe.id,{
                method:"DELETE", headers:{}
              });
              fetchGen.current++; await carregar(); setModalDetalhe(null);
            }} style={{background:"#7f1d1d22",border:"1px solid #7f1d1d",borderRadius:8,color:"#fca5a5",cursor:"pointer",fontSize:12,padding:"8px 14px"}}>🗑 {t("common.excluir")}</button>
          </div>
        </Modal>
      )}

      {modalEditar && (
        <Modal onClose={()=>setModalEditar(null)} largura={560}>
          <div style={{alignItems:"center",display:"flex",justifyContent:"space-between",marginBottom:20}}>
            <div>
              <div style={{color:"var(--accent2)",fontFamily:"monospace",fontSize:12}}>{modalEditar.id}</div>
              <div style={{fontSize:18,fontWeight:800}}>{t("agendamentos.editar_titulo","Editar agendamento")}</div>
            </div>
            <BtnFechar onClick={()=>setModalEditar(null)} />
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:12}}>
            <SeletorDataHora
              valor={modalEditar._dataLocal || ""}
              aoMudar={v=>setModalEditar(m=>({...m,_dataLocal:v}))}
              agendamentos={lista}
              idIgnorar={modalEditar.id}
              t={t}
            />
            {[["cliente_nome",t("agendamentos.nome")],["telefone",t("agendamentos.telefone")],["cpf",t("agendamentos.cpf_cnpj")],["email",t("agendamentos.email")],["placa",t("agendamentos.placa")],["veiculo",tSeg("agendamentos.veiculo")],["km",t("agendamentos.km")],["servico_solicitado",t("agendamentos.servico_solicitado")],["relato_cliente",t("agendamentos.relato_cliente")]].map(([campo,label])=>(
              <div key={campo}>
                <label style={{color:"var(--text2)",display:"block",fontSize:11,fontWeight:600,marginBottom:4,textTransform:"uppercase"}}>{label}</label>
                <input value={modalEditar[campo]||""} onChange={e=>setModalEditar(m=>({...m,[campo]:fmt(campo,e.target.value)}))} style={{width:"100%"}} />
              </div>
            ))}
            <div style={{display:"flex",gap:10,marginTop:8}}>
              <button className="btn-ghost" onClick={()=>setModalEditar(null)} style={{flex:1}}>{t("common.cancelar")}</button>
              <button className="btn-primary" onClick={salvarEdicao} disabled={salvandoEdicao} style={{flex:1,opacity:salvandoEdicao?0.6:1}}>
                {salvandoEdicao ? t("common.salvando","Salvando...") : t("common.salvar","Salvar alteracoes")}
              </button>
            </div>
          </div>
        </Modal>
      )}

      {modalOrc && (
        <ModalOrcamentoCompleto
          titulo={modalOrc.id + " — " + modalOrc.cliente_nome}
          /* Este fluxo manda a proposta ANTES de o cliente aprovar: o documento
             sai identificado como PRE-ORCAMENTO. O modal da O.S. e outro
             componente e continua intocado. */
          tipoDocumento="pre_orcamento"
          /* Cliente e veiculo para o documento de pre-orcamento. O componente
             nao recebia isso -- so o titulo com numero e nome. */
          cliente={{nome:modalOrc.cliente_nome, telefone:modalOrc.telefone, placa:modalOrc.placa, veiculo:modalOrc.veiculo, servico:modalOrc.servico_solicitado}}
          osId={modalOrc.id}
          tenantId={tenantId}
          modeloInicial={modeloOrcAg}
          featuresLiberadas={_featuresBackend}
          logoUrl={(planoAtual==="premium"||_featuresBackend.includes("logo_orcamento")) ? JSON.parse(localStorage.getItem(getConfigKey())||"{}").logo : null}
          onFechar={()=>setModalOrc(null)}
          onConfirmar={async (dados)=>{
            const total = dados.total;
            const r = await authFetch("/api/v1/dados/agendamentos/" + tenantId + "/" + modalOrc.id + "/orcamento", {
              method:"PATCH", headers:{"Content-Type":"application/json"},
              body:JSON.stringify({orcamento:{itens:dados.itens,total,modelo:dados.modelo,fotos:dados.fotos},orcamento_total:total,status:"orcamento_enviado"})
            });
            const falha = await erroDoServidor(r);
            if (falha) { window.alert(falha); return; }
            fetchGen.current++; carregar();
            setModalOrc(null); setModalDetalhe(null);
            adicionarNotificacao("aprovacao","Orcamento enviado",modalOrc.id+" -aguardando confirmacao",modalOrc.id);
          }}
        />
      )}
    </Layout>
  );
}
